import type { HTMLAttributes } from "react";
import type { Optional } from "../../types";
import styles from "./skeleton.module.css";

export type SkeletonProps = {
  count: number;
  containerStyle?: Optional<HTMLAttributes<HTMLDivElement>["style"]>;
  itemStyle?: Optional<HTMLAttributes<HTMLDivElement>["style"]>;
};

export function Skeleton({ count, containerStyle, itemStyle }: SkeletonProps) {
  return (
    <div className={styles.Container} style={containerStyle ?? {}}>
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <div
            key={`${index}-${count}`}
            className={styles.Row}
            style={itemStyle ?? {}}
            data-testid={`skeleton-${index}`}
            data-qa={`skeleton-${index}`}
          />
        ))}
    </div>
  );
}
